/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, TextFormat, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './insurance-claim-item.reducer';

export const InsuranceClaimItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const insuranceClaimItemList = useAppSelector(state => state.insuranceClaimItem.entities);
  const loading = useAppSelector(state => state.insuranceClaimItem.loading);
  const totalItems = useAppSelector(state => state.insuranceClaimItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="insurance-claim-item-heading" data-cy="InsuranceClaimItemHeading">
        <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.home.title">Insurance Claim Items</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/insurance-claim-item/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.home.createLabel">Create new Insurance Claim Item</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.insuranceClaimItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {insuranceClaimItemList && insuranceClaimItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('quantityProvided')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.quantityProvided">Quantity Provided</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('quantityProvided')} />
                </th>
                <th className="hand" onClick={sort('quantityApproved')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.quantityApproved">Quantity Approved</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('quantityApproved')} />
                </th>
                <th className="hand" onClick={sort('priceApproved')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.priceApproved">Price Approved</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('priceApproved')} />
                </th>
                <th className="hand" onClick={sort('explanation')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.explanation">Explanation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('explanation')} />
                </th>
                <th className="hand" onClick={sort('justification')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.justification">Justification</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('justification')} />
                </th>
                <th className="hand" onClick={sort('rejectionReason')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.rejectionReason">Rejection Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('rejectionReason')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.claim">Claim</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {insuranceClaimItemList.map((insuranceClaimItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/insurance-claim-item/${insuranceClaimItem.id}`} color="link" size="sm">
                      {insuranceClaimItem.id}
                    </Button>
                  </td>
                  <td>{insuranceClaimItem.quantityProvided}</td>
                  <td>{insuranceClaimItem.quantityApproved}</td>
                  <td>{insuranceClaimItem.priceApproved}</td>
                  <td>{insuranceClaimItem.explanation}</td>
                  <td>{insuranceClaimItem.justification}</td>
                  <td>{insuranceClaimItem.rejectionReason}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.InsuranceClaimItemStatus.${insuranceClaimItem.status}`} />
                  </td>
                  <td>{insuranceClaimItem.active ? 'true' : 'false'}</td>
                  <td>
                    {insuranceClaimItem.microSec ? (
                      <TextFormat type="date" value={insuranceClaimItem.microSec} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {insuranceClaimItem.timestampEntry ? (
                      <TextFormat type="date" value={insuranceClaimItem.timestampEntry} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>
                    {insuranceClaimItem.lastUpdated ? (
                      <TextFormat type="date" value={insuranceClaimItem.lastUpdated} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{insuranceClaimItem.cursor}</td>
                  <td>
                    {insuranceClaimItem.claim ? (
                      <Link to={`/insurance-claim/${insuranceClaimItem.claim.id}`}>{insuranceClaimItem.claim.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/insurance-claim-item/${insuranceClaimItem.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/insurance-claim-item/${insuranceClaimItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/insurance-claim-item/${insuranceClaimItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.insuranceClaimItem.home.notFound">No Insurance Claim Items found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={insuranceClaimItemList && insuranceClaimItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default InsuranceClaimItem;
